import { Component } from "solid-js";
import { invoiceDataInput, InvoiceDataOutput } from "~/trpc/api/invoices";
import { createZodForm } from "~/zod-forms";
import Button from "./Button";
import FormRow from "./FormRow";
import { maybeNumber } from "./helpers";
import Icon from "./Icon";
import NumberFormControl from "./NumberFormControl";
import { useRPC } from "./RPCProvider";
import StringFormControl from "./StringFormControl";

const SearchInvoice: Component<{
  onSuccess: (result: InvoiceDataOutput) => void;
}> = (props) => {
  const rpc = useRPC();

  const [Form, form] = createZodForm({
    schema: invoiceDataInput,
    initialInput: {},
  });
  const [uid, setUid] = form.bind("uid");
  const [mark, setMark] = form.bind("mark");

  return (
    <>
      <div
        class="text-light container-fluid d-flex justify-content-center align-items-center bg-image">
        <div class="dark-layer" />
        <div class="container-fluid d-flex flex-column align-items-center" style="z-index:1;">
          <Form
            class="text-center"
            handleSubmit={async (values) => {
              try {
                const mark = values.mark && maybeNumber(values.mark) !== undefined
                  ? BigInt(values.mark).toString()
                  : undefined;
                const reply = await rpc.query("getInvoice", {
                  id: values.id,
                  mark: mark,
                  uid: values.uid
                });
                if (!reply) {
                  throw new Error("No invoice");
                }
                props.onSuccess(reply);
              } catch (err) {
                console.error(err);
              }
            }}
          >
            <legend class="mb-3 mt-3">Αναζήτηση Παραστατικού</legend>
            <small>
              Για να αναζητήσετε παραστατικό χωρίς εισαγωγή στην εφαρμογή,
              παρακαλούμε χρησιμοποιήστε το ένα από τα δύο πεδία:
            </small>
            <div>
              <div class="d-flex flex-column justify-content-center justify-content-center align-items-center">
                <div class="ms-3 col-md-3 col-sm-3 p-2">
                  <StringFormControl
                    value={uid()}
                    onChange={(e) => setUid(e.currentTarget.value)}
                    errors={uid.dirty && uid.issues}
                    label="Uid"
                  />
                </div>
                <div class="ms-3 col-md-3 col-sm-3 p-2">
                  <NumberFormControl
                    value={
                      Number.isNaN(
                        Number(mark()?.toString())
                      )
                      ? undefined
                      : Number(mark()?.toString())
                    }
                    onChange={(e) => {
                      const newMark = maybeNumber(e.currentTarget.value);
                      setMark(
                        newMark != undefined
                          ? BigInt(newMark)
                          : undefined
                      )
                    }}
                    errors={mark.dirty && mark.issues}
                    label="Mark"
                    classList={{
                      ["ps-2"]: true
                    }}
                  />
                </div>
                <div class="ms-3 mt-2 mb-4">
                  <Button
                    type="submit"
                    disabled={
                      form.submitting() ||
                      form.lastSubmit()?.success === false ||
                      !form.valid()
                    }
                    kind="primary"
                  >
                    Αναζήτηση
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default SearchInvoice;
